import Navbar from './Navbar'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from './Footer'
import { useEffect } from 'react';

const MainLayout = () => {
  const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
  
    useEffect(() => {
      if (!hash) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, [pathname, hash]);
  
    return null;
  };

  ScrollToTop()
  return (
    <>
    <Navbar />
    <Outlet />
    <Footer />
    </>
  )
}

export default MainLayout